import { gql } from '@apollo/client';

const Fragments = {
  dictionary: gql`
    fragment dictionary on Dictionary {
      id
      name
      friendlyName
      isReadOnly
      isSystem
      dictionaryId
    }
  `
};

export default Fragments;
